var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRotateExclamation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0188 6H13.5H12.6V7.8H13.5H17.1H18V6.9V3.3V2.4H16.2V3.3V4.62375C15.3638 3.7125 14.58 2.87625 13.7587 2.23125C12.4613 1.21125 11.0213 0.599998 9 0.599998C5.31375 0.599998 2.07375 2.98125 0.94875 6.31125L2.655 6.88875C3.52875 4.29 6.0825 2.4 9 2.4C10.5825 2.4 11.64 2.85375 12.645 3.645C13.4213 4.25625 14.1338 5.0325 15.0188 6ZM9.9 5.1V4.2H8.1V5.1V9.3V10.2H9.9V9.3V5.1ZM9.9 13.2V11.4H8.1V13.2H9.9ZM0 15.6H1.8V14.7V13.2825C2.655 14.2275 3.45375 15.0975 4.2825 15.765C5.5575 16.7887 6.97875 17.4 9 17.4C12.6863 17.4 15.9263 15.0187 17.0513 11.6887L15.345 11.1112C14.4713 13.71 11.9175 15.6 9 15.6C7.42125 15.6 6.39 15.1462 5.4075 14.3587C4.67625 13.77 4.00875 13.035 3.18 12.1237L3.0675 12H4.5H5.4V10.2H4.5H0.9H0V11.1V14.7V15.6Z",
    fill: "#AEB5BC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateExclamation);
export default __webpack_public_path__ + "static/media/RotateExclamation.4df6a8f9.svg";
export { ForwardRef as ReactComponent };